import PropTypes from 'prop-types'
import React from 'react'
import ReactTooltip from 'react-tooltip'

export function DataTip({
  children,
  dataFor,
  dataTip,
  effect = 'solid',
  className = 'text-xs px-2 py-1',
  backgroundColor = 'rgba(55, 65, 81, 1)',
  show = true,
}) {
  return show ? (
    <>
      <div data-for={dataFor} data-tip={dataTip}>
        {children}
      </div>
      <ReactTooltip
        backgroundColor={backgroundColor}
        className={className}
        effect={effect}
        id={dataFor}
      />
    </>
  ) : (
    children
  )
}

DataTip.propTypes = {
  children: PropTypes.node.isRequired,
  dataFor: PropTypes.string.isRequired,
  dataTip: PropTypes.string.isRequired,
  effect: PropTypes.string,
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
  show: PropTypes.bool,
}

export default DataTip
